
import { Typography, Button, Box, Grid, Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Contactform from './Contactform';
import ModalImmo from './ModalImmo';
import ModalUntern from './ModalUntern';
import ModalErbrecht from './ModalErbrecht';
import ModalFamilie from './ModalFamilie';
import ModalVerein from './ModalVerein';
import ModalDialog from './ModalDialog';
import '../App.css';

const ScrollAnimation = () => {
    const [isVisible1, setIsVisible1] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);
    const [isVisible3, setIsVisible3] = useState(false);
    const [isVisible4, setIsVisible4] = useState(false);
    const [isVisible7, setIsVisible7] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const screenHeight = window.innerHeight;

            // ServiceItem 1
            const boxPosition1 = animatedBoxRef1.current.getBoundingClientRect().top;
            if (boxPosition1 < screenHeight * 0.8) {
                setIsVisible1(true);
            }

            // ServiceItem 2
            const boxPosition2 = animatedBoxRef2.current.getBoundingClientRect().top;
            if (boxPosition2 < screenHeight * 0.8) {
                setIsVisible2(true);
            }

            // ServiceItem 3
            const boxPosition3 = animatedBoxRef3.current.getBoundingClientRect().top;
            if (boxPosition3 < screenHeight * 0.8) {
                setIsVisible3(true);
            }

            // ServiceItem 4
            const boxPosition4 = animatedBoxRef4.current.getBoundingClientRect().top;
            if (boxPosition4 < screenHeight * 0.8) {
                setIsVisible4(true);
            }
            // ServiceItem 4
            const boxPosition7 = animatedBoxRef7.current.getBoundingClientRect().top;
            if (boxPosition7 < screenHeight * 0.8) {
                setIsVisible7(true);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    useEffect(() => {

function handleConsent(e) {
  const dpsName = "OpenStreetMap";

  const placeholder = document.getElementById("servicePlaceholder");
  const image = document.getElementById("imageplaceholder");
  const iframe = document.getElementById("osm-iframe");

  if (e.detail.type === "EXPLICIT" && e.detail[dpsName]) {
    // Consent gegeben: iFrame einfügen, Bild ausblenden
    if (placeholder && !iframe) {
      const dpsIframe = document.createElement("iframe");
      dpsIframe.id = "osm-iframe";
      dpsIframe.src =
        "//umap.openstreetmap.de/de/map/unbenannte-karte_56450?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=false&searchControl=null&tilelayersControl=false&embedControl=null&datalayersControl=false&onLoadPanel=none&captionBar=false&captionMenus=false&fullscreenControl=null&starControl=false&editinosmControl=false&measureControl=null&locateControl=null";
      dpsIframe.height = "100%";
      dpsIframe.width = "100%";
      dpsIframe.frameBorder = "0";
      dpsIframe.allowFullscreen = true;

      placeholder.appendChild(dpsIframe);

      if (image) {
        image.style.setProperty("display", "none", "important");
      }
    }
  } else if (e.detail.type === "EXPLICIT" && e.detail[dpsName] === false) {
    // Consent entzogen: iFrame entfernen, Bild anzeigen
    if (iframe && placeholder) {
      placeholder.removeChild(iframe);
    }
    if (image) {
      image.style.setProperty("display", "block", "important");
    }
  }
}
    window.addEventListener("ucConsentEvent", handleConsent);
        



//   function handleConsentEvent(e) {
//     console.log("1");
//     const consentEventName = "usercentrics_consent_given";
//     const serviceName = "OpenStreetMap";
//     const resourceLink = "//umap.openstreetmap.de/de/map/unbenannte-karte_56450?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=false&searchControl=null&tilelayersControl=false&embedControl=null&datalayersControl=false&onLoadPanel=none&captionBar=false&captionMenus=false&fullscreenControl=null&starControl=false&editinosmControl=false&measureControl=null&locateControl=null";
//     console.log("2");

//     if (e.type !== consentEventName) return;
//     if (!e.detail || e.detail.event !== "consent_status") return;
//     if (e.detail[serviceName] === true) {
//       const serviceIframe = document.createElement("iframe");
//       serviceIframe.src = resourceLink;
//       serviceIframe.width = "100%";
//       serviceIframe.height = "100%";
//       serviceIframe.frameBorder = "0";
//       serviceIframe.allowFullscreen = true;
//       serviceIframe.allow = "geolocation";
//       const placeholder = document.getElementById("servicePlaceholder");
//       if (placeholder) {
//         placeholder.appendChild(serviceIframe);
//          console.log("3");
//          document.getElementById("imageplaceholder").style.display = "none";
//       }
//     }
//   }

//   // Ersetze auch hier den Eventnamen!
//   window.addEventListener("{{Your consent event name}}", handleConsentEvent);

//   return () => {
//     window.removeEventListener("{{Your consent event name}}", handleConsentEvent);
//   };



}, []);

    const animatedBoxRef1 = React.useRef(null);
    const animatedBoxRef2 = React.useRef(null);
    const animatedBoxRef3 = React.useRef(null);
    const animatedBoxRef4 = React.useRef(null);
    const animatedBoxRef7 = React.useRef(null);


    // Visibility Notarinfo
    const [isVisible5, setIsVisible5] = useState(false);
    const [isVisible6, setIsVisible6] = useState(false);

    const toggleVisibility = (elementId) => {
        if (elementId === 'elementToToggle1') {

            setIsVisible5(!isVisible5);
        } else if (elementId === 'elementToToggle2') {
            setIsVisible6(!isVisible6);
        }
    };

    return (
        <Box className="containerMain">

            <div className="App">
                <main>
                    <div>
                        <Box className="heroWrapper section" id="start">
                            <img src="Oranienburg.webp" className='herobackimg' alt='Bild vom Schloss Oranienburg' />
                            <Box className='heroWrapperLayer'></Box>
                            <Container maxWidth="md" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>
                                <Box className="HeroBox">
                                    <img src='Logo-HK.png' className='HeroLogoImg' alt='Notarübo Holland und Kreusslein Logo mit Emblem ' />
                                    {/* <img src="Embem.png" className='HeroLogo' alt='Holland und Kreusslein Logo' /> */}
                                    <Typography variant='h1' align='center' color="textPrimary" gutterBottom className='invisible'>
                                        HOLLAND<span className="textaccent invisible">/</span>KREUßLEIN
                                    </Typography>
                                    <Typography variant="h2" align='center' color="textSecondary" className='invisible'>
                                        NOTARE
                                    </Typography>
                                    <div>
                                        <Button href="/#kontakt" variant='contained' className='heroCTA'>
                                            Kontakt
                                        </Button>
                                    </div>
                                </Box>


                            </Container>
                        </Box>



                        <Box className="mainWrapper">

                            <Container maxWidth="md" className="container subheroContainer">
                                <Box className="textBox">
                                    <Grid container justifyContent="center" spacing={2}>

                                        <Grid container item xs={12} sm={12} spacing={0}>
                                            <Box className="textBoxInner">
                                                <Typography variant='h3' className='subtitleH3'>Wir heißen Sie herzlich willkommen in unserem Notarbüro</Typography>
                                                <Typography variant='body1'>Als Notare bekleiden wir ein öffentliches Amt und sind zur Neutralität verpflichtet. Wir sind Ihre unparteiischen Berater, auch in kom­plizierten und folgenreichen Rechtsangelegenheiten. Wir sorgen dafür, dass Sie die Tragweite Ihrer Erklärungen und Ihres Handelns verstehen, und unterstützen Sie dabei, Ihre Anliegen rechtlich angemessen umzusetzen.</Typography>
                                            </Box>
                                        </Grid>

                                    </Grid>
                                </Box>

                                <Box className="textBox banner">
                                    <Grid container justifyContent="center" spacing={2}>

                                        <Grid container item xs={12} sm={12} spacing={0}>
                                            <Box className="textBoxInner">
                                                <Typography variant='body1'className="whiteText">Sehr geehrte Mandantinnen und Mandanten,<br/>
                                                zusätzlich zu unserem Büro in Oranienburg bieten sowohl Notar Matthias Sören Holland als auch Notar Dr. Matthias Kreußlein jeweils wöchentlich (in der Regel dienstags und donnerstags) Sprechtage in <b>16540 Hohen Neuendorf, Berliner Straße 56</b> an! Bitte vereinbaren Sie einen Termin.<br/>
                                                Ihre Notare Holland & Kreußlein</Typography>
                                            </Box>
                                        </Grid>

                                    </Grid>
                                </Box>

                                <Box className="textBox banner red">
                                    <Grid container justifyContent="center" spacing={2}>

                                        <Grid container item xs={12} sm={12} spacing={0}>
                                            <Box className="textBoxInner">
                                                <Typography variant='body1'className="whiteText">Achtung: Am <b>21.05.</b> werden wir auf Grund eines Telefonanlagenupdates voraussichtlich nur eingeschränkt telefonisch erreichbar sein.</Typography>
                                            </Box>
                                        </Grid>

                                    </Grid>
                                </Box>

                            </Container>




                            <Box className="bannerSectionBlue section" id="ctaform">
                                <Container maxWidth="md" className="container bannercontainer">
                                    <Typography variant='h2' className='sectionTitle fadeInOpac whiteText'>Bitte übermitteln Sie uns Ihr Anliegen online</Typography>
                                    <Typography variant='body1' className='fadeInOpac whiteText'>Damit wir Ihren Fall so schnell wie möglich bearbeiten können, klicken Sie bitte auf Ihr entsprechendes Anliegen und füllen Sie das Formular online aus. Nur so können wir sicherstellen, dass alle relevanten Informationen vollständig sind und Sie über Statusänderungen informiert bleiben.</Typography>

                                    <ModalDialog />
                                </Container>
                            </Box>

                            <Box className="section" id="info">
                                <Container maxWidth="md" className="leistungenContainer section" id="leistungen">
                                    <Typography variant='h2' className='sectionTitle fadeInOpac'>Unsere Leistungen</Typography>
                                    <Typography variant='h3' className='sectionTitle3 fadeInOpac'>Hier gelangen Sie zur Digitalen Notarplattform (DiNo)</Typography>
                                    <Grid container justifyContent="center" spacing={2} className="leistungenGrid">
                                        <Grid item xs={6} sm={4}>

                                            <Box className={`servOptItem ${isVisible1 ? 'visible' : ''}`} ref={animatedBoxRef1} id="soi1">
                                                <ModalImmo />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <Box className={`servOptItem ${isVisible1 ? 'visible' : ''}`} ref={animatedBoxRef2} id="soi2">
                                                <ModalFamilie />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <Box className={`servOptItem ${isVisible1 ? 'visible' : ''}`} ref={animatedBoxRef3} id="soi3">
                                                <ModalUntern />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <Box className={`servOptItem ${isVisible1 ? 'visible' : ''}`} ref={animatedBoxRef4} id="soi4">
                                                <ModalErbrecht />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <Box className={`servOptItem ${isVisible1 ? 'visible' : ''}`} ref={animatedBoxRef7} id="soi5">
                                                <ModalVerein />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Typography variant='body1'>Haben Sie Fragen? Nehmen Sie <a href="#kontakt">Kontakt</a> zu uns auf!</Typography>
                                </Container>

                                <Container maxWidth="md" className="container section" id="notare">
                                    <Typography variant='h2' className='sectionTitle'>
                                        Ihre Notare
                                    </Typography>

                                    <Grid container justifyContent="center" spacing={2} className="notareGrid">

                                        <Grid item xs={12} sm={12} className='notarElement'>

                                            <Box className="notarInnerBox">
                                                <Box className="notarImgWrapper">
                                                    {/* <img src='notar.jpg' className='notarImg' alt='Noat Matthias Sören' /> */}
                                                </Box>
                                                <Box>
                                                    <Typography variant='h3' className='subtitleH3'>Notar Matthias Sören Holland</Typography>
                                                    <Typography variant='body1' paragraph>Matthias Sören Holland ist seit dem 1. Juli 2023 Notar auf Lebenszeit in Oranienburg und Partner der Sozietät der Notare Holland & Kreußlein. Er ist der Amtsnachfolger der <span className="nobreak">Notarin a.D. Martina Fritzlar</span>. Beglaubigungen sowie ausgewählte Beurkundungen können auch in englischer oder französischer Sprache vorgenommen werden.</Typography>
                                                    <Button className='btnSecondary' onClick={() => toggleVisibility('elementToToggle1')}>{`${isVisible5 ? 'Einklappen' : 'Mehr zur Person'}`}</Button>
                                                </Box>

                                            </Box>

                                            <Box id="elementToToggle1" className={`notarBodyTextWrapper ${isVisible5 ? 'visible' : ''}`}>
                                                <Typography variant='body1' paragraph className='notarBodyText'>
                                                    Nach dem Studium der Politik- und Verwaltungswissenschaften und des Öffentlichen Rechts an der Universität Potsdam sowie der Rechtswissenschaft an der Humboldt-Universität zu Berlin absolvierte <span className="nobreak">Matthias Sören Holland</span> das Rechtsreferendariat am Kammergericht in Berlin, u.a. mit Stationen am Bundesverfassungsgericht und im Bundesministerium des Innern. Seit 2012 war er Stipendiat der Studienstiftung des Deutschen Volkes.<br /><br />
                                                    2019 wurde er in den Notaranwärterdienst des Landes Brandenburg aufgenommen und war dort zunächst dem Notar Karsten Strüben in Strausberg zur Ausbildung zugewiesen. 2021 wurde er an das Deutsche Notarinstitut (DNotI) in Würzburg abgeordnet. Darauf folgten weitere Zuweisungen nach Prenzlau, Königs Wusterhausen, Eberswalde und Oranienburg.<br /><br />

                                                    Neben seiner Notartätigkeit ist <span className="nobreak">Matthias Holland</span> u.a. als freier Referent am Deutschen Notarinstitut (DNotI) in Würzburg tätig und ist Vorstandsmitglied und Schriftführer des Förderkreises des Notarinstituts der Humboldt-Universität zu Berlin. Zudem ist er an etlichen Veröffentlichungen im öffentlichen Recht und zu notarrechtlichen Themen beteiligt.</Typography>
                                            </Box>


                                        </Grid>
                                        <Grid item xs={12} sm={12} className='notarElement'>

                                            <Box className="notarInnerBox">
                                                <Box className="notarImgWrapper">
                                                    {/* <img src='notar.jpg' className='notarImg' alt='Notar Matthias Holland' /> */}
                                                </Box>
                                                <Box>
                                                    <Typography variant='h3' className='subtitleH3'>Notar Dr. Matthias Kreußlein</Typography>
                                                    <Typography variant='body1' paragraph>Dr. Matthias Kreußlein ist seit dem 1. April 2021 Notar auf Lebenszeit in Oranienburg und Partner der Sozietät der Notare Holland & Kreußlein. Er ist der Amtsnachfolger der <span className="nobreak">Notarin a.D. Edda Wiroth</span>. Beglaubigungen sowie ausgewählte Beurkundungen können auch in englischer Sprache vorgenommen werden.</Typography>
                                                    <Button className='btnSecondary' onClick={() => toggleVisibility('elementToToggle2')}>{`${isVisible6 ? 'Einklappen' : 'Mehr zur Person'}`}</Button>
                                                </Box>

                                            </Box>

                                            <Box id="elementToToggle2" className={`notarBodyTextWrapper ${isVisible6 ? 'visible' : ''}`}>
                                                <Typography variant='body1' paragraph className='notarBodyText'>
                                                    Im Anschluss an das Studium der Rechtswissenschaft an der Friedrich-Schiller-Universität in Jena war <span className="nobreak">Dr. Matthias Kreußlein</span> zunächst als wissenschaftlicher Mitarbeiter bei <span className="nobreak">Notar Prof. Dr. Heribert Heckschen</span> in Dresden angestellt. Anschließend absolvierte er das Rechtsreferendariat am Kammergericht in Berlin und wurde 2016 zu einem kapitalmarktrechtlichen Thema promoviert. Nach einer Tätigkeit als Anwalt in Berlin wandte er sich 2017 dem Notaranwärterdienst des Landes Brandenburg zu. In diesem Rahmen war er <span className="nobreak">Notarin Keslin Damke</span> in Potsdam (2017–2019) sowie <span className="nobreak">Notar Hans-Ulrich Tegge</span> in Königs Wusterhausen (2019) und <span className="nobreak">Notar Thomas Woinar</span> in Frankfurt/Oder (2019–2021) zur Ausbildung zugewiesen.<br /><br />

                                                    Neben seiner Notartätigkeit wurde <span className="nobreak">Dr. Matthias Kreußlein</span> mit einem Lehrauftrag der Rechtswissenschaftlichen Fakultät der Universität Potsdam betraut und ist Vorstandsmitglied und Schatzmeister des Brandenburger Notarbunds. Darüber hinaus ist er an diversen Veröffentlichungen, v.a. im Gesellschaftsrecht beteiligt.</Typography>
                                            </Box>


                                        </Grid>


                                    </Grid>
                                </Container>



                                <Box className="bannerSectionBlue section" id="ctaform">
                                    <Container maxWidth="md" className="container bannercontainerMiddle">
                                        {/* <Typography variant='h2' className='sectionTitle fadeInOpac whiteText'>Bitte übermitteln Sie uns Ihr Anliegen online</Typography> */}
                                        <Typography variant='body1' className='fadeInOpac whiteText'>Wir sind Notare mit dem Amtssitz in Oranienburg. Unser Amtsbereich umfasst alle Städte und Gemeinden in der Zuständigkeit des Amtsgerichtes Oranienburg, d.h. neben Oranienburg auch Kremmen, Hennigsdorf, Velten, Oberkrämer, Birkenwerder, Hohen Neuendorf, Glienicke/Nordbahn, Mühlenbecker Land und Leegebruch. In diesen Orten nehmen wir auch Auswärtstermine vor Ort wahr. Außerhalb unseres Amtsbereiches ist uns dies grundsätzlich nicht gestattet. Gleichwohl dürfen wir an unserem Amtssitz auch Beurkundungen über jeglichen Grundbesitz in ganz Deutschland vornehmen. Wir haben online Zugang zu Grundbüchern in allen Bundesländern. Gleiches gilt für Gesellschaften in ganz Deutschland (GmbHs, Aktiengesellschaften etc.) und – ungeachtet ihrer Staatsangehörigkeit – auch für Mandanten mit Wohnsitz außerhalb unseres Amtsbereichs.<br /><br /></Typography>
                                        <Typography variant='body1' className='fadeInOpac whiteText'>In unseren Amtsräumen in der Prenzlauer Straße 11 in Oranienburg heißen wir Sie herzlich willkommen!</Typography>
                                    </Container>
                                </Box>


                                <Container maxWidth="md" className="container section" id="kontakt">
                                    <Typography variant='h2' className='sectionTitle'>
                                        Kontaktieren Sie uns!
                                    </Typography>
                                    <Contactform />
                                    <br /><br />
                                    <Typography variant='body1' paragraph>
                                        Hier finden Sie uns:
                                    </Typography>
                                    
                                    
                                    <Box className="contactMap">
                                        <div id="servicePlaceholder"></div> 
                                        {/* <iframe className='cookieconsent-optin-marketing' data-usercentrics="OpenStreetMap" data-cookieblock-src="//umap.openstreetmap.de/de/map/unbenannte-karte_56450?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=false&searchControl=null&tilelayersControl=false&embedControl=null&datalayersControl=false&onLoadPanel=none&captionBar=false&captionMenus=false&fullscreenControl=null&starControl=false&editinosmControl=false&measureControl=null&locateControl=null" width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" ></iframe> */}
                                        <img src="map.webp" id="imageplaceholder" className='mapImageConsent cookieconsent-optout-marketing' alt="Umgebungskarte des Notarbüros in Oranienburg" />                                       
                                    </Box>
                                   
                                    
                                    <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden Sie <a href="https://www.google.com/maps/dir//Notare+Holland+%26+Kreu%C3%9Flein,+Prenzlauer+Str.+11,+16515+Oranienburg/@52.7596784,13.2514147,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x4164e8afdba0e241:0x9b19020e624be46c!2m2!1d13.2539073!2d52.7596041!3e0?hl=en&entry=ttu" target="_blank">hier</a>.</Typography>
                                    <Typography variant='body1' paragraph className="contactMapRouteInfo">Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet.
                                    Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von Google. Dort erhalten Sie auch weitere Informationen zu den diesbezüglichen Rechten und Einstellungsmöglichkeiten zum Schutze der Privatsphäre: <a href="http://www.google.de/intl/de/policies/privacy" target='_blank'>http://www.google.de/intl/de/policies/privacy</a></Typography>

                                </Container>

                                



                            </Box>

                        </Box>

                    </div>
                </main >
            </div >

        </Box>
    );
};



export default ScrollAnimation;